__turbopack_context__.v({
  "body": "Drawer-module__lV9dxa__body",
  "content": "Drawer-module__lV9dxa__content",
});
